







import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class CloudflarePlayer extends Vue {
  @Prop({ default: "" }) videoId!: string;

  isVideoLoading: boolean = true;

  mounted() {
    if (this.videoId) {
      this.addVideoScript();
    }
  }

  @Watch("videoId")
  onVideoIdChange(newValue: string, oldValue: string) {
    this.isVideoLoading = true;
    this.removeVideoScript(oldValue);
    if (newValue) {
      this.addVideoScript();
    }
  }

  beforeDestroy() {
    if (this.videoId) {
      this.removeVideoScript(this.videoId);
    }
  }

  addVideoScript() {
    if (this.videoId) {
      const script = document.createElement("script");
      script.setAttribute("data-cfasync", "false");
      script.setAttribute("type", "text/javascript");
      script.setAttribute("id", this.videoId);
      script.setAttribute(
        "src",
        `https://embed.videodelivery.net/embed/r4xu.fla9.latest.js?video=${this.videoId}`
      );

      document.head.appendChild(script);

      this.isVideoLoading = false;
    }
  }

  removeVideoScript(videoId: string) {
    const oldElement = document.getElementById(videoId);
    if (oldElement) {
      oldElement.remove();
    }
  }
}
